<template>
  <SimpleCard
    color="#fff"
    icon="mdi-crown"
    title="受信ランキング"
    v-bind:subTitle="subPageTitle"
  >
    <template v-slot:text>
      <div v-for="(item, index) in items" :key="index">
        <v-row>
          <v-col cols="3">
            <v-icon large :color="rankColor[item.RECEIVE_RANKING - 1]">
              mdi-crown
            </v-icon>
            <span class="h3">{{ item.RECEIVE_RANKING }}位</span>
          </v-col>
          <v-col cols="9" class="py-1 px-0 text-left">
            <Avatar
              v-if="item.USER_AVATER"
              :src="item.USER_AVATER"
              :size="40"
              class="mr-2"
            />
            {{ item.USER_NAME }}({{ item.USER_POSITION }})
            <v-col class="py-1 px-0">
              受け取り回数： {{ item.RECEIVE_COUNT }}回
            </v-col>
          </v-col>
        </v-row>
      </div>

      <EmptyState
        v-if="!items.length"
        imagePath="empty-state-ranking.svg"
        size="150"
        title="受信ランキングは見つかりませんでした"
      />
    </template>
  </SimpleCard>
</template>

<script>
import axios from 'axios';
import { format } from '@/utils/day.js';
import config from '../../../const.js';
import message from '../../../message.js';
import { generateMessage } from '@/utils/common.js';
import {
  getSessionStorageItem,
  makeDateTimeStr,
  makeYyMmStr,
} from '../../../common.js';

export default {
  name: 'RecieveRanking',
  props: {
    pageKind: String,
    biginDay: String,
    endDay: String,
  },

  data() {
    return {
      userInfo: {},
      items: [],
      subPageTitleStr: 'に最もプラスの氣を受け取ったユーザー',
    };
  },

  computed: {
    rankColor() {
      return ['#ffd700', '#c0c0c0', '#815a2b', '#000', '#000'];
    },
  },

  created() {
    // created時にitemsを初期化
    this.items = [];
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;

    if (this.pageKind == config.PURASUNOKI_TOP_PAGE) {
      this.subPageTitle = makeYyMmStr() + this.subPageTitleStr;
    } else {
      this.subPageTitle = '絞り込み期間内' + this.subPageTitleStr;
    }
  },

  mounted() {
    //----- 受信ランキングを取得
    // プラスの氣受信ランキングリクエストGET
    axios
      .get(
        config.CONNECT_URL +
          '/Encouragements/RecieveRanking/' +
          this.userInfo.SESSION_ID +
          '/' +
          this.userInfo.USER_ID +
          '/' +
          this.userInfo.ORGANIZATION_KEY +
          '/' +
          makeDateTimeStr('S', this.biginDay) +
          '/' +
          makeDateTimeStr('E', this.endDay)
      )
      .then((response) => {
        // プラスの氣データ取得
        if (this.pageKind == config.PURASUNOKI_TOP_PAGE) {
          // TOP画面処理
          let rankItems = [];
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].RECEIVE_RANKING <= 3) {
              rankItems.push(response.data[i]);
            }
          }
          this.items = rankItems;
        } else {
          // ランキング画面処理
          this.items = response.data;
        }
        // アバター接続URL作成
        for (var avaterCnt = 0; avaterCnt < this.items.length; avaterCnt++) {
          this.items[avaterCnt].USER_AVATER =
            this.items[avaterCnt].USER_AVATER + '?' + format('YYYYMMDDHHmmss');
        }
      })
      .catch((error) => {
        if (error.response.status == 404) {
          alert(generateMessage(message.NOT_FOUND, ['プラスの氣']));
        }
        if (error.response.status == 400) {
          alert(generateMessage(message.MSG_ERROR_SESSION + error));
        } else {
          alert(generateMessage(message.MSG_ERROR_SYTEM + error));
        }
      })
      .finally(() => {
        // Ranking.vueに受信集計完了メッセージ送信
        this.$emit('catchRecvMessage', '受信集計完了');
      });
  },
};
</script>
